// Admin.js

import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Typography, Checkbox, List } from 'antd';
import './Admin.css';

const { Title } = Typography;

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users`, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      const data = await response.json();
      if (response.ok) {
        setUsers(data);
      } else {
        alert(data.error);
      }
    } catch (error) {
      console.error('Failed to fetch users:', error);
      alert('Failed to fetch users. Please try again.');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (response.ok) {
        alert('User added successfully');
        fetchUsers();
      } else {
        alert(data.error);
      }
    } catch (error) {
      console.error('Failed to add user:', error);
      alert('Failed to add user. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (username) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/remove-account`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Ensure cookies are sent
        body: JSON.stringify({ username }),
      });

      const data = await response.json();
      if (response.ok) {
        alert('User deleted successfully');
        fetchUsers(); // Refresh the user list
      } else {
        alert(data.error);
      }
    } catch (error) {
      console.error('Failed to delete user:', error);
      alert('Failed to delete user. Please try again.');
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-form">
        <Title level={3} className="text-center">
          Add User
        </Title>
        <Form name="add-user" onFinish={onFinish} layout="vertical">
          <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Please input the username!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Please input the password!' }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item name="isAdmin" valuePropName="checked">
            <Checkbox className="custom-checkbox" style={{ color: 'white' }}>Admin</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Add User
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="user-list">
        <Title level={3} className="text-center">
          Users
        </Title>
        <List
          bordered
          dataSource={users}
          renderItem={(user) => (
            <List.Item
              actions={!user.isAdmin ? [<Button type="link" className="delete-button" onClick={() => handleDelete(user.username)}>X</Button>] : []}
            >
              {user.username} {user.isAdmin && <strong>[Admin]</strong>}
            </List.Item>
          )}
        />
      </div>
    </div>
  );
};

export default Admin;
